export enum ClaimsRedirectValues {
  CEDDeclare = "declare",
  CEDFollow = "followup",
  SFPJContracts = "contrats",
  SFPJConsultation = "consult",
  SFPJDeclarationLitiges = "decl_litiges",
  SFPJLitiges = "litiges",
  // A VALIDER POUR LES BRANCHEMENTS RMA
  RMAHealthSheet = "rma_health_sheet",
  RMADeathAttestations = "rma_death_attestations",
  RMASinister = "rma_sinister",
  RMASinisterFollow = "rma_sinister_follow",
  // A VALIDER POUR LES BRANCHEMENTS ALTIMA
  ALTIMAFollow = "altimafollowup",
  ALTIMADeclaration = "altimadeclaration",
}
